const FETCH_INCIDENT_DETAIL_REPORT = "report::incident-detail::fetch";

export { FETCH_INCIDENT_DETAIL_REPORT };
